module.exports = __webpack_public_path__ + "dc52d373ff613d4b5eb4bf37e18453ed.pdf";